import { Select, styled } from '@mui/material';

export const SelectFilter = styled(Select)(({ theme }) => ({
  width: '14.5rem',
  height: '3.715rem',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '10rem',
    height: '3.715rem',
  },
}));
